<template>
    <div>
        <form @submit.prevent="saveSetting">
            <tabs class="ses-tabs" :fill="0" :pills="0" :activeTab="0">
                <card shadow>
                    <tab-pane :key="0" title="Values" :id="0">
                        <p><b>Example:</b> Good day [customer-name]!</p>
                        <p><b>Values:</b> [survey-quote-number] [survey-project-name] [survey-company-name] [survey-consultant-name] [survey-customer-name] [survey-customer-email] [survey-customer-code] [survey-customer-phone] [survey-date] [survey-location] [customer-name] [customer-email] [customer-code] [customer-bp-code] [customer-company] [customer-title] [customer-ext] [customer-phone] [customer-fax] [customer-cellphone] [customer-address] [customer-country] [customer-city] [customer-state] [customer-zipcode] [follow-up-project-list] [gift-card-name] [gift-card-amount] [gift-card-image]</p>
                    </tab-pane>
                    <tab-pane :key="1" title="Recipients" :id="1">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Additional Recipients</label>
                                    <template v-if="settings.fue_additional_recipients.length > 0">
                                        <div v-for="(email, key) in settings.fue_additional_recipients" :key="key" class="d-flex align-items-center mb-1">
                                            <input type="text" class="form-control" style="width: 19em;" :value="email" @change="add_recipient($event, key)">
                                            <button class="btn ml-1 mr-1" type="button" @click="add_row_recipient">+</button>
                                            <template v-if="key > 0">
                                                <button class="btn" type="button" @click="remove_row_recipient(key)">-</button>
                                            </template>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="d-flex align-items-center mb-1">
                                            <input type="text" class="form-control" style="width: 19em;" @change="add_recipient($event, 0)">
                                            <button class="btn ml-1 mr-1" type="button" @click="add_row_recipient">+</button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Email Feedback Report Recipient</label>
                                    <input type="text" class="form-control" ref="fue_feedback_report_recipient" v-model="settings.fue_feedback_report_recipient">
                                </div>
                            </div>
                        </div>
                    </tab-pane>
                    <tab-pane :key="2" title="Delays" :id="2">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Delay for FIRST INITIAL follow up <span class="required-indicator">*</span></label>
                                    <small>Send automated email for initial projects that have not been followed up on that are older than (x) number of days.</small>
                                    <div class="d-flex align-items-center mt-2">
                                        <input type="number" min="0" class="form-control delay mr-1" ref="fue_delay_first_initial" v-model="settings.fue_delay_first_initial">
                                        <span>Day(s)</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Delay for REPEATED INITIAL follow up <span class="required-indicator">*</span></label>
                                    <small>Send automated email on any initial project that has been followed up on at least once, but not within (x) number of days.</small>
                                    <div class="d-flex align-items-center mt-2">
                                        <input type="number" min="0" class="form-control delay mr-1" ref="fue_delay_repeated_initial" v-model="settings.fue_delay_repeated_initial">
                                        <span>Day(s)</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Delay for FIRST FINAL follow up <span class="required-indicator">*</span></label>
                                    <small>Send automated email for final projects that have not been followed up on that are older than (x) number of days.</small>
                                    <div class="d-flex align-items-center mt-2">
                                        <input type="number" min="0" class="form-control delay mr-1" ref="fue_delay_first_final" v-model="settings.fue_delay_first_final">
                                        <span>Day(s)</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Delay for REPEATED FINAL follow up <span class="required-indicator">*</span></label>
                                    <small>Send automated email on any final project that has been followed up on at least once, but not within (x) number of days.</small>
                                    <div class="d-flex align-items-center mt-2">
                                        <input type="number" min="0" class="form-control delay mr-1" ref="fue_delay_repeated_final" v-model="settings.fue_delay_repeated_final">
                                        <span>Day(s)</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tab-pane>
                    <tab-pane :key="3" title="Messages" :id="3">
                        <div class="section">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Questionnaire Success Message</label>
                                        <textarea class="form-control" ref="fue_questionnaire_success_msg" v-model="settings.fue_questionnaire_success_msg"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label>Image</label>
                                        <input type="file" class="form-control" ref="fue_questionnaire_success_img_file" @change="on_select_file($event, 'fue_questionnaire_success_img')" accept="image/*">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="text-center" style="position: relative;">
                                        <button class="btn btnRemoveImg" type="button" @click="settings.fue_questionnaire_success_img = ''"><span class="fa fa-close"></span></button>
                                        <img v-if="settings.fue_questionnaire_success_img" :src="settings.fue_questionnaire_success_img" style="width: 20em;">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="section">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Gift Card Success Message</label>
                                        <textarea class="form-control" ref="fue_gift_card_success_msg" v-model="settings.fue_gift_card_success_msg"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label>Image</label>
                                        <input type="file" class="form-control" ref="fue_gift_card_success_img_file" @change="on_select_file($event, 'fue_gift_card_success_img')" accept="image/*">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="text-center" style="position: relative;">
                                        <button class="btn btnRemoveImg" type="button" @click="settings.fue_gift_card_success_img = ''"><span class="fa fa-close"></span></button>
                                        <img v-if="settings.fue_gift_card_success_img" :src="settings.fue_gift_card_success_img" style="width: 20em;">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="section">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Feedback Submitted Message</label>
                                        <textarea class="form-control" ref="fue_feedback_submitted_msg" v-model="settings.fue_feedback_submitted_msg"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label>Image</label>
                                        <input type="file" class="form-control" ref="fue_feedback_submitted_img_file" @change="on_select_file($event, 'fue_feedback_submitted_img')" accept="image/*">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="text-center" style="position: relative;">
                                        <button class="btn btnRemoveImg" type="button" @click="settings.fue_feedback_submitted_img = ''"><span class="fa fa-close"></span></button>
                                        <img v-if="settings.fue_feedback_submitted_img" :src="settings.fue_feedback_submitted_img" style="width: 20em;">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="section">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Pause Follow Up Success Message</label>
                                        <textarea class="form-control" ref="fue_pause_follow_up_success_msg" v-model="settings.fue_pause_follow_up_success_msg"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label>Image</label>
                                        <input type="file" class="form-control" ref="fue_pause_follow_up_success_img_file" @change="on_select_file($event, 'fue_pause_follow_up_success_img')" accept="image/*">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="text-center" style="position: relative;">
                                        <button class="btn btnRemoveImg" type="button" @click="settings.fue_pause_follow_up_success_img = ''"><span class="fa fa-close"></span></button>
                                        <img v-if="settings.fue_pause_follow_up_success_img" :src="settings.fue_pause_follow_up_success_img" style="width: 20em;">
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </tab-pane>
                    <!-- <tab-pane :key="4" title="Generate Link" :id="4"></tab-pane> -->
                    <tab-pane :key="5" title="Gift Card" :id="5">
                        <div class="form-group">
                            <label>Gift Card <span class="required-indicator">*</span></label>
                            <select-gift-card :default_gift_card="settings.fue_gift_card" @select="select_gift_card"></select-gift-card>
                        </div>
                        <button class="btn btn-black" type="button" @click="cancel_gift_cards" :disabled="isGiftCardSubmitting">
                            <template v-if="isGiftCardSubmitting">Processing <span class="fa fa-spinner fa-pulse"></span></template>
                            <template v-else>Cancel Gift Cards</template>
                        </button>
                        <div><small>*Gift cards that are not claimed within 90 days.</small></div>
                    </tab-pane>
                </card>
            </tabs>
            <div class="row mt-2">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Email Subject <span class="required-indicator">*</span></label>
                        <input type="text" class="form-control" ref="fue_subject" v-model="settings.fue_subject">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Send Test Email</label>
                        <div class="d-flex align-items-center">
                            <input type="email" class="form-control mr-1" ref="test_email" v-model="test_email">
                            <button class="btn btn-black" type="button" @click="sendTest" :disabled="isTestSubmitting">
                                <template v-if="isTestSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                <template v-else>Send</template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Email Template <span class="required-indicator">*</span></label>
                        <div ref="fue_template">
                            <template v-if="load_editor">
                                <editor
                                    api-key="pl6x3z60hczh55voaiqnr46bv5a5oqdg35w8ped317eeqibb"
                                    v-model="settings.fue_template"
                                    :init="{
                                        height: 600,
                                        plugins: 'image code imagetools link',
                                        images_upload_url: '/api/settings/upload_file',
                                        convert_urls: false,
                                        automatic_uploads: true
                                    }"
                                >
                                </editor>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="button-group">
                        <template v-if="isSettingSubmitting">
                            <button class="btn btn-black" disabled><span class="fa fa-spinner fa-pulse"></span></button>
                        </template>
                        <template v-else>
                            <button class="btn btn-black" type="submit">Save</button>
                            <button class="btn btn-black" type="submit" @click="save_continue = true">Save & Continue</button>
                        </template>
                    </div>
                </div>
            </div>
        </form>

        <modal class="modal-project" :show="showProjectModal" @close="showProjectModal = false" :closeOnbackdrop="false">
            <template slot="header"><h3>Projects</h3></template>
            <template>
                <div class="row">
                    <div class="col-md-12">
                        <div class="filter-wrapper">
                            <p class="title">Manage Filters:</p>
                            <div class="filter-container">
                                <div class="filter-item">
                                    <date-range-picker :label="updated_at_label" control-container-class="nice-select" opens="right" @select="getRange" @clear="clearRange"></date-range-picker>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.project_name" @change="filter_list">
                                        <option value="all">Job Name: All</option>
                                        <option v-for="(value, key) in project_names" :key="key" :value="value">{{ value }}</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.company_name" @change="filter_list">
                                        <option value="all">Customer: All</option>
                                        <option v-for="(value, key) in companies" :key="key" :value="value">{{ value }}</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.state" @change="filter_list">
                                        <option value="all">State: All</option>
                                        <option v-for="(value, key) in states" :key="key" :value="value">{{ value }}</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.city" @change="filter_list">
                                        <option value="all">City: All</option>
                                        <option v-for="(value, key) in cities" :key="key" :value="value">{{ value }}</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.country" @change="filter_list">
                                        <option value="all">Country: All</option>
                                        <option v-for="(value, key) in countries" :key="key" :value="value">{{ value }}</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.last_follow_up_date" @change="filter_list">
                                        <option value="all">Last Follow up: All</option>
                                        <option v-for="(month, key) in months" :key="key" :value="(key+1) < 10 ? '0'+(key+1) : (key+1)">{{ month }}</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.start_date" @change="filter_list">
                                        <option value="all">Est. Start: All</option>
                                        <option v-for="(month, key) in months" :key="key" :value="(key+1) < 10 ? '0'+(key+1) : (key+1)">{{ month }}</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.follow_up_type" @change="filter_list">
                                        <option value="all">Follow Up Type: All</option>
                                        <option value="FIRST">FIRST</option>
                                        <option value="REPEATED">REPEATED</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.with_response_code" @change="filter_list">
                                        <option value="all">With Response Code: All</option>
                                        <option value="YES">YES</option>
                                        <option value="NONE">NONE</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.pending_close" @change="filter_list">
                                        <option value="all">Pending Close: All</option>
                                        <option value="YES">YES</option>
                                        <option value="NO">NO</option>
                                    </select>
                                </div>
                                <div class="filter-item">
                                    <select class="nice-select" v-model="filters.status" @change="filter_list">
                                        <option value="all">Status: All</option>
                                        <option value="INITIAL">INITIAL</option>
                                        <option value="FINAL">FINAL</option>
                                    </select>
                                </div>
                                <div class="filter-item response-filter">
                                    <div class="nice-select">
                                        <div>Res. Code: </div>
                                        <select v-model="filters.project_awarded" @change="filter_list">
                                            <option value="all">Bid</option>
                                            <option value="W">W</option>
                                            <option value="L">L</option>
                                            <option value="P">P</option>
                                        </select>
                                        <select v-model="filters.awarded_to_ses" @change="filter_list">
                                            <option value="all">Proposal</option>
                                            <option value="Y">Y</option>
                                            <option value="N">N</option>
                                        </select>
                                        <select v-model="filters.job_lost_reason" @change="filter_list">
                                            <option value="all">Reason</option>
                                            <option value="C">C</option>
                                            <option value="P">P</option>
                                            <option value="F">F</option>
                                            <option value="O">O</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="filter-item">
                                    <date-range-picker :label="response_date_label" control-container-class="nice-select" opens="right" @select="getResponseDateRange" @clear="clearResponseDateRange"></date-range-picker>
                                </div>
                                <div class="filter-item search-filter">
                                    <input type="text" placeholder="Search" v-model="filters.search" @change="filter_list">
                                    <button type="button" @click="filter_list"><i class="fa fa-search"></i></button>
                                </div>
                                <div class="filter-reset-btn">
                                    <a href="javascript:void(0)" title="Refresh" @click="reset_filter">
                                        <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <div id="ses-list" class="list-proj" @scroll="scroll_list">
                                <div class="row list-head">
                                    <div class="col sort-false pr-0"><input type="checkbox" :checked="default_select_all" @change="select_all_projects"></div>
                                    <div class="col pl-0" data-key="quote_number" @click="sort_list">Case #</div>
                                    <div class="col" data-key="updated_at" @click="sort_list">Date Submitted</div>
                                    <div class="col" data-key="project_name" @click="sort_list">Job Name</div>
                                    <div class="col" data-key="company_name" @click="sort_list">Customer</div>
                                    <div class="col" data-key="customer_email" @click="sort_list">Email Recipient</div>
                                    <div class="col" data-key="last_follow_up_date" @click="sort_list">Last Follow Up Date</div>
                                    <div class="col" data-key="managers" @click="sort_list">Region</div>
                                    <div class="col" data-key="city" @click="sort_list">City</div>
                                    <div class="col" data-key="state" @click="sort_list">State</div>
                                    <div class="col" data-key="country" @click="sort_list">Country</div>
                                    <div class="col" data-key="start_date" @click="sort_list">Est. Start</div>
                                    <div class="col" data-key="total_price" @click="sort_list">Amount</div>
                                </div>
                                <div class="list-row" v-for="row in projects" :key="row.id">
                                    <div class="row list-data">
                                        <div class="col pr-0"><input type="checkbox" :checked="selected_projects.indexOf(row.id) != -1" @change="select_project($event, row.id, row.customer_email)"></div>
                                        <div class="col pl-0">{{ row.quote_number }}</div>
                                        <div class="col">{{ row.updated_at }}</div>
                                        <div class="col">{{ row.project_name }}</div>
                                        <div class="col">{{ row.company_name }}</div>
                                        <div class="col" style="word-break: break-all;">{{ row.customer_email }}</div>
                                        <div class="col">{{ row.last_follow_up_date }}</div>
                                        <div class="col">{{ row.managers }}</div>
                                        <div class="col">{{ row.city }}</div>
                                        <div class="col">{{ row.state }}</div>
                                        <div class="col">{{ row.country }}</div>
                                        <div class="col">{{ row.start_date }}</div>
                                        <div class="col">{{ row.total_price }}</div>
                                    </div>
                                    <div class="row list-action">
                                        <div class="col-md-12 action-wrap">
                                            <badge class="badge-dot mr-2" :type="row.status.toLowerCase()">
                                                <span class="status">{{ row.status.toLowerCase() }}</span>
                                            </badge>
                                            <badge v-if="row.pending_close == 'Yes'" class="badge-dot mr-2" type="pending-close">
                                                <span class="status">Pending Close</span>
                                            </badge>
                                            <badge v-if="row.response_code" class="badge-dot mr-2" type="response-code">
                                                <span class="status">{{ row.response_code }}</span>
                                            </badge>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <template v-if="projects.length == 0 && !isListLoading">
                                <p class="no-results-msg">No results found</p>
                            </template>
                            <template v-if="isListLoading">
                                <div class="progress">
                                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <div class="d-flex align-items-center" style="flex: auto;">
                    <div><b>Total Results:</b> {{ total_results }}</div>
                    <div class="ml-4"><b>Selected:</b> {{ selected_projects.length }} <button class="btn btnDeselectAll" type="button" @click="deselect_all_projects"><span class="fa fa-close"></span></button></div>
                    <div class="ml-4"><b>Distinct Emails:</b> {{ distinct_emails.length }}</div>
                </div>
                <div>
                    <button class="btn" @click="showProjectModal = false">Cancel</button>
                    <button class="btn btn-black" @click="projectSubmit" :disabled="isProjectSubmitting">
                        <template v-if="isProjectSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                        <template v-else>Send</template>
                    </button>
                </div>
            </template>
        </modal>

    </div>
</template>
<script>
import DateRangePicker from '../../components/DateRangePicker'
import SelectGiftCard from '../../components/SelectGiftCard.vue'
import Editor from '@tinymce/tinymce-vue'
import moment from 'moment'

export default {
    components: {
        DateRangePicker,
        SelectGiftCard,
        Editor
    },
    data() {
        return {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            showProjectModal: false,
            isProjectSubmitting: false,
            isSettingSubmitting: false,
            isTestSubmitting: false,
            isGiftCardSubmitting: false,
            isListLoading: false,
            project_names: [],
            companies: [],
            states: [],
            cities: [],
            countries: [],
            projects: [],
            page: 1,
            last_page: 1,
            order_by: 'updated_at',
            order: 'desc',
            total_results: 0,
            filters: {
                search: '',
                project_name: 'all',
                company_name: 'all',
                state: 'all',
                city: 'all',
                country: 'all',
                last_follow_up_date: 'all',
                start_date: 'all',
                with_response_code: 'all',
                pending_close: 'all',
                follow_up_type: 'all',
                status: 'all',
                updated_at: 'all',
                project_awarded: 'all',
                awarded_to_ses: 'all',
                job_lost_reason: 'all',
                response_date: 'all'
            },
            updated_at_label: 'Date Submitted: All',
            response_date_label: 'Response Date: All',
            default_select_all: false,
            selected_projects: [],
            distinct_emails: [],
            select_all_filters: [],
            test_email: '',
            save_continue: false,
            save_test: false,
            load_editor: false,
            settings: {
                fue_subject: '',
                fue_delay_first_initial: 0,
                fue_delay_repeated_initial: 0,
                fue_delay_first_final: 0,
                fue_delay_repeated_final: 0,
                fue_gift_card: {},
                fue_feedback_report_recipient: '',
                fue_additional_recipients: [],
                fue_template: '',
                fue_questionnaire_success_msg: '',
                fue_questionnaire_success_img: '',
                fue_questionnaire_success_img_file: '',
                fue_gift_card_success_msg: '',
                fue_gift_card_success_img: '',
                fue_gift_card_success_img_file: '',
                fue_feedback_submitted_msg: '',
                fue_feedback_submitted_img: '',
                fue_feedback_submitted_img_file: '',
                fue_pause_follow_up_success_msg: '',
                fue_pause_follow_up_success_img: '',
                fue_pause_follow_up_success_img_file: ''
            },
            gift_card_recipients: [],
            selectedProjectsIncludeEmail: {}
        }
    },
    beforeMount() {
        this.get_settings()
    },
    mounted() {
        let def_order = document.querySelector('#ses-list .list-head .col[data-key='+this.order_by+']')
        def_order.classList.add(this.order)
        def_order.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')

        setTimeout(() => {
            this.load_editor = true
        }, 1000)

        this.get_project_filters()
    },
    methods: {
        get_settings() {
            let keys = [
                'fue_subject',
                'fue_delay_first_initial',
                'fue_delay_repeated_initial',
                'fue_delay_first_final',
                'fue_delay_repeated_final',
                'fue_gift_card',
                'fue_feedback_report_recipient',
                'fue_additional_recipients',
                'fue_template',
                'fue_questionnaire_success_msg',
                'fue_questionnaire_success_img',
                'fue_gift_card_success_msg',
                'fue_gift_card_success_img',
                'fue_feedback_submitted_msg',
                'fue_feedback_submitted_img',
                'fue_pause_follow_up_success_msg',
                'fue_pause_follow_up_success_img'
            ]

            this.$http.get('/api/settings?keys=' + JSON.stringify(keys))
                .then((response) => {
                    let settings = response.data.data
                    for(let n in settings) {
                        let key = settings[n].setting_key
                        let value = settings[n].setting_value

                        if(key == 'fue_gift_card') {
                            this.settings[key] = JSON.parse(value)
                        } else if(key == 'fue_additional_recipients') {
                            value = JSON.parse(value)
                            if(!Array.isArray(value)) {
                                value = []
                            }
                            this.settings[key] = value
                        } else {
                            this.settings[key] = value
                        }
                    }
                })
        },
        get_projects() {
            this.isListLoading = true
            this.$http.get('/api/follow-up-emails/projects?page=' + this.page 
                + '&order_by=' + this.order_by
                + '&order=' + this.order
                + '&filters=' + JSON.stringify(this.filters)
            )
                .then(response => {
                    if(this.page == 1) {
                        this.projects = []
                    }
                    response.data.data.forEach(row => {
                        this.projects.push(row)
                    })
                    this.last_page = response.data.last_page
                    this.total_results = response.data.total
                    this.isListLoading = false

                    let filters = JSON.stringify(this.filters)
                    if(this.select_all_filters.indexOf(filters) != -1) {
                        this.default_select_all = true
                    } else {
                        this.default_select_all = false
                    }
                })
        },
        get_project_filters() {
            this.$http.get('/api/follow-up-emails/project_filters')
                .then(response => {
                    this.project_names = response.data.project_names
                    this.companies = response.data.companies
                    this.states = response.data.states
                    this.cities = response.data.cities
                    this.countries = response.data.countries
                })
        },
        scroll_list(e) {
            if(e.target.scrollTop + e.target.clientHeight >= (e.target.scrollHeight - 50) && !this.isListLoading) {
                this.page += 1
                if(this.page <= this.last_page) {
                    this.get_projects()
                }
            }
        },
        sort_list(e) {
            if(!this.isListLoading) {
                Array.from(document.querySelectorAll('#ses-list .list-head .col')).forEach((el) => {
                    el.classList.remove('asc', 'desc')
                })
                let element = document.querySelector('#ses-list .list-head .col[data-key='+e.target.dataset.key+']')
                this.order_by = e.target.dataset.key
                this.order = element.dataset.order || 'asc'
                element.classList.add(this.order)
                element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
                this.page = 1
                this.projects = []
                this.get_projects()
            }
        },
        filter_list() {
            this.page = 1
            this.projects = []
            this.get_projects()
        },
        reset_filter() {
            this.filters = {
                search: '',
                project_name: 'all',
                company_name: 'all',
                state: 'all',
                city: 'all',
                country: 'all',
                last_follow_up_date: 'all',
                start_date: 'all',
                with_response_code: 'all',
                pending_close: 'all',
                follow_up_type: 'all',
                status: 'all',
                updated_at: 'all',
                project_awarded: 'all',
                awarded_to_ses: 'all',
                job_lost_reason: 'all',
                response_date: 'all'
            }
            this.updated_at_label = 'Date Submitted: All'
            this.response_date_label = 'Response Date: All'
            this.page = 1
            this.projects = []
            this.get_projects()
        },
        getRange(range) {
            this.filters.updated_at = moment(range.startDate).format('YYYY/MM/DD') + ' - ' + moment(range.endDate).format('YYYY/MM/DD')
            this.updated_at_label = this.filters.updated_at
            this.filter_list()
        },
        clearRange() {
            this.filters.updated_at = 'all'
            this.updated_at_label = 'Date Submitted: All'
            this.filter_list()
        },
        getResponseDateRange(range) {
            this.filters.response_date = moment(range.startDate).format('YYYY/MM/DD') + ' - ' + moment(range.endDate).format('YYYY/MM/DD')
            this.response_date_label = this.filters.response_date
            this.filter_list()
        },
        clearResponseDateRange() {
            this.filters.response_date = 'all'
            this.response_date_label = 'Response Date: All'
            this.filter_list()
        },
        select_gift_card(gift_card) {
            this.settings.fue_gift_card = gift_card
        },
        add_recipient(e, key) {
            this.settings.fue_additional_recipients[key] = e.target.value
        },
        add_row_recipient() {
            this.settings.fue_additional_recipients.push('')
        },
        remove_row_recipient(key) {
            this.settings.fue_additional_recipients.splice(key, 1)
        },
        saveSetting() {
            this.isSettingSubmitting = true
            let fdata = new FormData()

            let recipients = this.settings.fue_additional_recipients
            this.settings.fue_additional_recipients = []
            for(let x in recipients) {
                if(recipients[x]) {
                    this.settings.fue_additional_recipients.push(recipients[x])
                }
            }

            for(let n in this.settings) {
                let value = this.settings[n]
                if(n == 'fue_gift_card' || n == 'fue_additional_recipients') {
                    value = JSON.stringify(value)
                }
                fdata.append(n, value)
            }

            return this.$http.post('/api/follow-up-emails/save', fdata)
                .then(() => {
                    this.isSettingSubmitting = false

                    if(this.save_continue) {
                        this.showProjectModal = true
                        this.save_continue = false
                        this.deselect_all_projects()
                        this.reset_filter()

                    } else if(this.save_test) {
                        this.save_test = false
                    } else {
                        alert('Saved!')
                    }
                })
                .catch(error => {
                    if(error.response.data.message == 'validation_error') {
                        this.validation_error(error.response.data.errors)
                    }
                    this.isSettingSubmitting = false
                })
        },
        projectSubmit() {
            if(this.selected_projects.length > 0) {
                this.isProjectSubmitting = true

                this.$http.post('/api/follow-up-emails/send', { ids: this.selected_projects })
                    .then(() => {
                        this.isProjectSubmitting = false
                        this.showProjectModal = false
                        alert('Sent!')
                    })
                    .catch(() => {
                        alert('Something went wrong!')
                        this.isProjectSubmitting = false
                    })
            } else {
                alert('No project selected!')
            }
        },
        select_all_projects(e) {
            this.isListLoading = true
            this.page = 1
            this.projects = []

            this.$http.get('/api/follow-up-emails/projects?select_all_ids=true'
                + '&order_by=' + this.order_by
                + '&order=' + this.order
                + '&filters=' + JSON.stringify(this.filters)
            )
                .then(response => {

                    // save select all filter
                    let filters = JSON.stringify(this.filters)
                    if(e.target.checked) {
                        if(this.select_all_filters.indexOf(filters) == -1) {
                            this.select_all_filters.push(filters)
                        }
                    } else {
                        this.select_all_filters.splice(this.select_all_filters.indexOf(filters), 1)
                    }
                    // select all project
                    let ids = response.data
                    for(let n in ids) {
                        this.select_project(e, ids[n].id, ids[n].customer_email)
                    }

                    this.get_projects()
                })
        },
        select_project(e, id, email) {
            if(e.target.checked) {
                if(this.selected_projects.indexOf(id) == -1) {
                    this.selected_projects.push(id)
                    this.selectedProjectsIncludeEmail[id] = email
                }
                if(email) {
                    if(this.distinct_emails.indexOf(email.toLowerCase()) == -1) {
                        this.distinct_emails.push(email.toLowerCase())
                    }
                }
                this.default_select_all = this.isAllSelected()
            } else {
                this.selected_projects.splice(this.selected_projects.indexOf(id), 1)
                delete this.selectedProjectsIncludeEmail[id]
                if(email) {
                    // this.distinct_emails.splice(this.distinct_emails.indexOf(email.toLowerCase()), 1)
                    this.distinct_emails = [...new Set(Object.values(this.selectedProjectsIncludeEmail).map(email => email.toLowerCase()))]
                }
                this.default_select_all = false
            }
        },
        isAllSelected() {
            let allIsSelected = true
            for (let i = 0; i < this.projects.length; i++) {
                if (this.selected_projects.indexOf(this.projects[i].id) === -1) {
                    allIsSelected = false
                    break
                }
            }
            return allIsSelected
        },
        deselect_all_projects() {
            this.select_all_filters = []
            this.selected_projects = []
            this.distinct_emails = []
            this.selectedProjectsIncludeEmail = {}
            this.default_select_all = false
        },
        on_select_file(event, key) {
            const files = event.target.files
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this.settings[key] = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.settings[`${key}_file`] = files[0]
        },
        sendTest() {
            this.save_test = true
            this.isTestSubmitting = true

            this.saveSetting().then(() => {
                this.$http.post('/api/follow-up-emails/test', { test_email: this.test_email })
                    .then(() => {
                        this.isTestSubmitting = false
                        alert('Sent!')
                    })
                    .catch(error => {
                        if(error.response.data.message == 'validation_error') {
                            this.validation_error(error.response.data.errors)
                        }
                        this.isTestSubmitting = false
                    })
             })
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('.hasError')).forEach(function(el) { 
                el.classList.remove('hasError');
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                        ref.scrollIntoView({ block: 'center' })
                    }
                }
            }

            if(Object.keys(errors).length == 1) {
                alert(errors[Object.keys(errors)[0]][0])
            } else {
                alert('Please fill all required data.')
            }
        },
        cancel_gift_cards() {
            let conf = confirm('Are you sure you want to cancel the gift cards?')
            if(conf) {
                alert('Please wait, this may take a while to process.')
                this.isGiftCardSubmitting = true
                this.$http.post('/api/follow-up-emails/cancel_gift_cards')
                    .then(() => {
                        alert('Success!')
                        this.isGiftCardSubmitting = false
                    })
                    .catch(() => {
                        alert('Something went wrong!')
                        this.isGiftCardSubmitting = false
                    })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
#ses-list {
    min-width: 768px;
    padding-right: 12px;
    max-height: 450px;
    .list-head .col {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('/api/public/img/bg.png');
        background-position: center right;
        background-repeat: no-repeat;
        cursor: pointer;
        white-space: normal;
        &.asc {
            background-image: url('/api/public/img/trans-asc.png');
        }
        &.desc {
            background-image: url('/api/public/img/trans-desc.png');
        }
        &.sort-false {
            background-image: none;
            cursor: default;
        }
    }
}
.delay {
    width: 4em;
}
.section {
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 1em;
    padding-bottom: 0.5em;
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.row-detail {
    display: flex;
    align-items: center;
    word-break: break-all;
    padding: 0.2em;
    label {
        min-width: 122px;
        font-weight: bold;
        margin: 0;
        margin-right: 0.5em;
    }
}
.modal-project.modal::v-deep {
    .modal-dialog {
        max-width: 1200px;
    }
    .modal-body {
        min-height: 660px;
    }
    .modal-footer {
        justify-content: flex-start;
    }
}
.ses-tabs::v-deep {
    .nav-item {
        flex-basis: 15% !important;
    }
}
.btnDeselectAll {
    font-size: 11px;
    border-radius: 50%;
    height: 24px;
    width: 24px;
    padding: 0;
}
.btnRemoveImg {
    display: block;
    position: absolute;
    right: 1em;
    font-size: 11px;
    border-radius: 50%;
    height: 24px;
    width: 24px;
    padding: 0;
}
.list-proj .row .badge-dot { margin: 0 0 0 6px !important; line-height: 16px; }
.list-proj .row .action-wrap { white-space: nowrap; position: relative; z-index: 2; text-align: left; }
.list-proj .row .action { display: inline-block; padding: 7px; border: 0; letter-spacing: 0.3px; color: #fff; text-decoration: none; min-width: 86px; cursor: pointer; color: #fff; background-color: #5cb85c; margin-left: 6px; vertical-align: middle; }
.list-proj .row .action span { display: inline-block; background: #459e45; padding: 2px 7px; width: 29px; margin: -7px 2px -7px -8px; font-size: 17px; line-height: 26px; text-align: center; }
.badge {
    cursor: text;
    pointer-events: none;
    border-radius: 0;
    min-width: 84px;
    padding: 7px;
    border: 0;
    letter-spacing: .3px;
    color: #fff;
    text-decoration: none;
}
.badge-initial {
    background-color: #1848e4;
}
.badge-final {
    background-color: gold;
}
.badge-response-code {
    color: #000;
}
.badge-pending-close {
    color: #c90000;
}
@media (min-width: 1200px) {
    .ses-content .filter-wrapper .filter-item {
        width: 16.3% !important;
    }
    .ses-content .filter-wrapper .search-filter {
        width: 16.3% !important;
    }
    .ses-content .filter-wrapper .response-filter {
        width: 260px !important;
    }
}
.response-filter {
    min-width: 260px !important;
    .nice-select {
        display: flex;
        align-items: center;
        font-size: 10px;
        text-transform: uppercase;
        select {
            background: none;
            border: 0;
            text-transform: uppercase;
        }
    }
}
</style>